import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TitleGifDisplayCard"] */ "/app/src/components/nivaran/common/TitleGifDisplayCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageInformationDisplayCard"] */ "/app/src/components/nivaran/main/ImageInformationDisplayCard.tsx");
